import React, { useContext } from "react";
import Card from "../../../../UX/Card/Card";
import OptionCard from "../../../../UX/OptionCard/OptionCard";
import { TranslationContext } from "../../../../Providers/TranslationProvider";
import { ProductOptionStepsContext } from "../../../../Providers/ProductOptionStepsProvider";
import StepContainer from "../../../../UX/StepContainer/StepContainer";

const OptionsCards = ({ step }) => {
    const { trans } = useContext(TranslationContext);
    const {
        onClearSelectedProductOptions,
        onSelectProductOption,
        onOpenModal,
        onOpenExtraInfoModal
    } = useContext(ProductOptionStepsContext);

    const Buttons = (
        <>
            <button
                onClick={() => onOpenModal(step.id)}
                className="mr-4 lg:mr-6 mb-2 text-gray-600 hover:underline text-sm"
            >
                <i className="fas fa-info-circle" /> Meer informatie
            </button>
            <button
                onClick={() => onClearSelectedProductOptions(step.id)}
                className="mr-4 lg:mr-6 mb-2 text-gray-600 hover:underline text-sm "
            >
                <i className="fas fa-times" /> Verwijder keuze
            </button>
        </>
    );

    return (
        <StepContainer step={step} buttons={Buttons}>
            <div className="flex flex-wrap -mx-2">
                {step.options.map(option => (
                    <OptionCard
                        onOpenExtraInfoModal={onOpenExtraInfoModal}
                        key={option.value}
                        type={step.id}
                        option={option}
                        selectOption={onSelectProductOption}
                    />
                ))}
            </div>
        </StepContainer>
    );
};

export default OptionsCards;
